/* Maeve & Co — show premium display names on cart items + product cards */
(function () {
  'use strict';
  var N = {
    "period-swimsuit-women-leak-proof-one-piece-swimwear-off-shoulder-black": "Océane",
    "brown-period-swimsuit-women-leak-proof-one-piece-swimwear-off-shoulder": "Marina",
    "womens-linen-shorts-cotton-linen-blend-drawstring-waist-relaxed-fit": "Simone",
    "womens-linen-shorts-wide-leg-high-waist-belted-tailored": "Colette",
    "womens-linen-shorts-pure-linen-high-waist-wide-leg-tailored": "Margaux",
    "womens-maxi-dress-backless-tiered-striped-summer-sundress": "Amalie",
    "womens-midi-dress-striped-sleeveless-square-neck-a-line-pocket": "Elodie",
    "womens-bardot-dress-off-shoulder-satin-maxi-bodycon-evening-dress": "Aurelia",
    "anti-chafing-shorts-women-slip-shorts-mid-thigh-high-waist-seamless": "Elin",
    "womens-maxi-dress-chiffon-square-neck-ruched-bodice-lace-up-back": "Seraphine",
    "womens-maxi-dress-lace-backless-strappy-floor-length-evening": "Ophelia",
    "womens-linen-blouse-cotton-linen-lapel-collar-button-front-short-sleeve": "Margot",
    "womens-waistcoat-tailored-v-neck-button-front-sleeveless": "Blair",
    "womens-linen-set-waistcoat-shorts-v-neck-button-front-co-ord": "Camille",
    "womens-button-vest-top-fitted-v-hem-sleeveless-going-out-top": "Remy",
    "shenxunlu-backpack-hip-dress": "Celestine",
    "one-shoulder-pleated-bodysuit-dress": "Vivienne",
    "womens-lace-bodycon-dress": "Fleur",
    "slim-fit-deep-v-neck-dress": "Delphine",
    "elegant-mesh-panel-slim-dress": "Anouk",
    "elegant-one-shoulder-satin-dress": "Isolde",
    "womens-dress": "Rosalind",
    "halter-neck-sequin-bodycon-dress": "Bijou",
    "one-shoulder-strapless-dress-with-sexy-backless-design-and-high-slit": "Cordelia",
    "sexy-rhinestone-strapless-dress": "Estelle",
    "womens-high-waist-wide-leg-shorts": "Sienna",
    "floral-high-waisted-denim-shorts": "Florence",
    "casual-short-sleeve-shirt-and-shorts-set": "Ines",
    "2026-new-style-sleeveless-two-piece-beach-dress-set-solid-color-tassel-sexy-shorts-aliexpress-tie-up-european-and-american-cross-border": "Marisol",
    "casual-shorts-v-neck": "Cleo",
    "womens-knit-tank-top-and-trousers": "Willa",
    "womens-casual-pants-set": "Odette",
    "low-rise-non-stretch-washed-straight-leg-jeans": "Dakota",
    "denim-wide-leg-pants": "Marlowe",
    "womens-washed-loose-micro-flared-mid-rise-jeans": "Frankie",
    "womens-high-waisted-elastic-wide-leg-denim-pants": "Quinn",
    "casual-denim-tube-top-with-braided-rope-wide-leg-pants-set": "Reese",
    "women-jeans": "Sloane",
    "womens-fleece-lined-straight-leg-jeans": "Wren",
    "high-waist-wide-leg-linen-blend-drawstring-pants": "Palma",
    "work-pants": "Reeve",
    "womens-high-waist-wide-leg-denim-pants": "Harper",
    "denim-printed-straight-leg-pants": "Indira",
    "womens-corduroy-trousers": "Rowan",
    "retro-washed-wide-leg-denim-trousers": "Juno",
    "womens-work-pants": "Sage",
    "loose-harem-jeans-for-women": "Isla",
    "casual-loose-fitting-wide-leg-pants": "Nova",
    "womens-denim-harem-pants-high-waist-wide-leg": "Maren",
    "womens-casual-pants": "Bianca",
    "womens-elastic-waist-wide-leg-palazzo-harem-pants-casual": "Alma",
    "bohemian-drawstring-wide-leg-pants-with-shell-decoration": "Saffron",
    "sleeveless-backless-bow-dress": "Scarlett",
    "lace-strap-slim-dress": "Lila",
    "cut-out-hip-hugging-knitted-sleeveless-dress": "Noa",
    "one-shoulder-strapless-striped-figure-hugging-dress": "Talia",
    "solid-color-round-neck-sleeveless-elastic-waist-womens-dress": "Mira",
    "design-sense-satin-split-dress": "Elowen",
    "elegant-neck-bandage-dress": "Vera",
    "womens-dress-1": "Serena",
    "satin-pleated-backless-slip-dress": "Cosette",
    "elegant-one-shoulder-tight-waist-banquet-dress": "Minette",
    "sleeveless-backless-bow-bodycon-dress": "Genevieve"
  };
  function handleOf(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function apply() {
    var links = document.querySelectorAll('a.cart-item__name, .card__heading a');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-maeve-named')) continue;
      var h = handleOf(a.getAttribute('href'));
      if (h && N[h]) {
        a.textContent = N[h];
        a.setAttribute('data-maeve-named', '1');
      }
    }
  }
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () { scheduled = false; apply(); }, 0);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
  window.addEventListener('pageshow', apply);
})();
